import { LOGGER_CONFIG } from '../constants/LOGGER_CONFIG';
import { getEnvironment, ENVIRONMENTS } from '@shared/utils';

/**
 * @group Functions
 * 
 * @summary
 * <blockquote>Check if a domain is enabled for logging in current environment</blockquote>
 * 
 * @param domain - The domain to check
 * @returns True if the domain is enabled for logging in the current environment
 * 
 * @example
 * ```typescript
 * const isEnabled = isDomainEnabled('auth'); // boolean
 * ```
 **/
export const isDomainEnabled = (domain: string): boolean => {
  const result = getEnvironment();
  const env = result.match({
    ok: (env) => env,
    err: () => ENVIRONMENTS.DEVELOPMENT // Default to development if environment detection fails
  });
  return LOGGER_CONFIG.domains[domain]?.[env] ?? false;
}; 